































































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import {
  ITemplatesProviderData,
  ITemplatesProviderMethods
} from "@/models/providers/templates";
import { ITemplate } from "@/models/templates";
import { DataModules } from "@/store/modules/data";
import { NotificationChannelCodes } from "@/data/enums/notifications";
import { UpmindObjectToDataModuleMapping } from "@/data/enums/objects";
import { TemplateTypes } from "@/data/enums/templates";

@Component
export default class TemplatesSelect extends Vue {
  // Inject
  @Inject({ from: "templatesProvider" })
  public templatesProvider!: () => ITemplatesProviderData;

  @Inject({ from: "templatesProviderMethods" })
  public $templatesMethods!: ITemplatesProviderMethods;

  // Props

  @Prop({ required: true })
  public readonly value!: ITemplate["id"];

  @Prop({ default: false })
  public readonly isDisabled!: boolean;

  @Prop({ default: false })
  public readonly field!: string;

  @Prop({ default: undefined })
  public readonly addEditModalProps!: any;

  // Data

  public querySearch = "";

  // Computed

  public get $templatesData() {
    return this.templatesProvider();
  }

  public get selectedTemplate() {
    return this.$templatesData.templates?.find(i => i.id === this.value);
  }

  public get filteredTemplates() {
    return this.$_.filter(this.$templatesData.templates, t => {
      return this.$_.includes(
        t.name.toLowerCase(),
        this.querySearch.toLowerCase()
      );
    });
  }

  public get templateChannel() {
    return this.selectedTemplate?.channel;
  }

  public get templateCategory() {
    return this.selectedTemplate?.category;
  }

  public get isNotificationTemplate() {
    return this.selectedTemplate?.type === TemplateTypes.NOTIFICATION;
  }

  public get canSendTestEmail() {
    return (
      this.templateCategory &&
      this.isNotificationTemplate &&
      this.templateChannel?.code === NotificationChannelCodes.EMAIL &&
      this.$_.has(
        UpmindObjectToDataModuleMapping,
        this.templateCategory?.code || ""
      )
    );
  }

  // Methods

  public onTemplateSelected(template: ITemplate) {
    if (!template) return;
    this.$emit("input", this.field ? template[this.field] : template);
  }

  public openAddTemplateModal() {
    this.$templatesMethods.openAddEditModal({
      props: this.addEditModalProps,
      events: {
        // Auto select newly created template
        success: template => {
          this.onTemplateSelected(template);
        }
      }
    });
  }

  public openSendTestEmailModal() {
    this.$store.dispatch(
      `data/${DataModules.TEMPLATES}/openSendTestEmailModal`,
      {
        parent: this,
        props: {
          templateId: this.selectedTemplate?.id,
          objectType: this.selectedTemplate?.category?.code,
          recipientTypeId: this.selectedTemplate?.recipient_type_id
        }
      }
    );
  }
}
